import React from 'react'
import {
    Box,
    Flex,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import Breadcrumb from '../../../components/breadcrumb'
import PropTypes from 'prop-types'
import Link from '@salesforce/retail-react-app/app/components/link'
import routingObject from '../../../utils/static-routes'

const ProductRegistrationHeader = ({variant, index, productId}) => {
    const styles = useMultiStyleConfig('ProductRegistration')
    const searchBackPath = `${routingObject.PRODUCT_REGISTRATION_PATH}/search`

    const categories = [
        {
            id: 1,
            name: (
                <FormattedMessage
                    id="login_form.message.back_to_homepage"
                    defaultMessage="Back to Homepage"
                />
            ),
        },
        {
            id: 2,
            name: (
                <FormattedMessage
                    id="product_registration.title"
                    defaultMessage="Register your product"
                />
            ),
        },
    ]
    const redirectionPath =
        index === 1
            ? `${routingObject.PRODUCT_REGISTRATION_PATH}`
            : index === 2
            ? searchBackPath
            : `${routingObject.PRODUCT_REGISTRATION_PATH}/account-detail?code=` + productId

    return (
        <Flex {...styles.titleContainer}>
            {variant === 'product' ? (
                <Link {...styles.link} to={redirectionPath}>
                    <Text>
                        <FormattedMessage
                            id="product_registration_header.link"
                            defaultMessage="Go back"
                        />
                    </Text>
                </Link>
            ) : (
                <Flex maxW="100%">
                    <Breadcrumb homepage={true} {...styles.breadcrumb} categories={categories} />
                </Flex>
            )}
            {!index && (
                <Box {...styles.titleSection}>
                    <Text as="h1" {...styles.title}>
                        <FormattedMessage
                            id="product_registration.title"
                            defaultMessage="Register your product"
                        />
                    </Text>
                    <Text {...styles.subtitle}>
                        <FormattedMessage
                            id="product_registration.subtitle"
                            defaultMessage="Register your product to unlock a world of benefits."
                        />
                    </Text>
                </Box>
            )}
            {index === 1 && (
                <Box {...styles.titleSection}>
                    <Text as="h1" {...styles.title}>
                        <FormattedMessage
                            id="product_registration.select_category"
                            defaultMessage="Step 1/3: Select Your Product"
                        />
                    </Text>
                </Box>
            )}
            {index === 2 && (
                <Box {...styles.titleSection}>
                    <Text as="h1" {...styles.title}>
                        <FormattedMessage
                            id="product_registration.enter_product_details"
                            defaultMessage="Step 2/3: Login or Register"
                        />
                    </Text>
                </Box>
            )}
            {index === 3 && (
                <Box {...styles.titleSection}>
                    <Text as="h1" {...styles.title}>
                        <FormattedMessage
                            id="product_registration.review_and_submit"
                            defaultMessage="Step 3/3: Upload your proof of purchase"
                        />
                    </Text>
                </Box>
            )}
        </Flex>
    )
}

export default ProductRegistrationHeader

ProductRegistrationHeader.propTypes = {
    variant: PropTypes.string,
    index: PropTypes.number,
    productId: PropTypes.string,
}
